import styles from "./taskcard.module.css";
import { ChevronDown, Copy, Edit, MoreVertical, Trash2 } from "react-feather";
import { Dropdown } from "react-bootstrap";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const orderedDayList = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const ordLabels = ["1st", "2nd", "3rd", "4th"];

const TaskCard = ({ item, setDeleteTaskModalOpen, setArchiveTaskModalOpen, setIsArchive, setEditTaskModalOpen, setDetailsTaskModalOpen, setSelectedId, setCopyTaskModalOpen }) => {
  const { user, isAuthenticated } = useAuth0();
  const [repeatText, setRepeatText] = useState('-');
  const redirect = useHistory();

  const formatWeeks = (weeks) => {
    if (weeks.length > 2) {
      const last = weeks.pop();
      return weeks.join(', ') + ' & ' + last;
    } else if (weeks.length === 2) {
      return weeks[0] + ' & ' + weeks[1];
    } else if (weeks.length === 1) {
      return weeks[0];
    }
    return '';
  }

  useEffect(() => {
    if (item?.frequency === "Daily" && item?.days.length > 0) {
      setRepeatText(item?.days.length === 7 ? "Everyday" : item?.days.sort((a, b) => orderedDayList.indexOf(a) - orderedDayList.indexOf(b)).join(", "));
    }

    if (item?.frequency === "Weekly" && item?.weeks.length > 0) {
      setRepeatText(formatWeeks(item?.weeks.sort().map((w) => ordLabels[w - 1])) + " week(s) of each month");
    }
  }, [item])

  return (<div className={`${styles.ProspectCard}`} onClick={(e) => { setDetailsTaskModalOpen(true); setSelectedId(item?.id); }}>
    <div className={`${styles.ProspectCardUnder}`}>
      <div className={`${styles.ProspectCardHeadSection}`}>

        {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("task:create") > -1 || user["https://propertydek.com/permissions"].indexOf("task:update") > -1 || user["https://propertydek.com/permissions"].indexOf("task:delete") > -1) && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
            <MoreVertical />
          </Dropdown.Toggle>

          <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("task:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditTaskModalOpen(true); setSelectedId(item?.id); }}>
              <Edit /> Edit
            </Dropdown.Item>}
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("task:create") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setCopyTaskModalOpen(true); setSelectedId(item?.id); }}>
              <Copy /> Copy
            </Dropdown.Item>}
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("task:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteTaskModalOpen(true); setSelectedId(item?.id); }}>
              <Trash2 /> Delete
            </Dropdown.Item>}
          </Dropdown.Menu>
        </Dropdown>}

        <div className={`${styles.ProsIMGSec}`}>
          <img src="/static/img/tasklist.svg" alt="" />
        </div>
        <div className={`${styles.HeadConSec}`}>
          <p className={`${styles.ProsUserName}`}>
            <span className={`${styles.UserName}`}>{item?.title}</span>
          </p>
          <p className={`${styles.ProsUserName} ${styles.Small}`}>{item?.technician_name !== '' ? item?.technician_name + ' Assigned' : '-'}</p>
        </div>
      </div>
      <div className={`${styles.ProspectCardBodySec}`}>
        <ul>
          <li>
            <p className={`${styles.Title}`}># of Tasks:</p>
            <p className={`${styles.Content}`}>{item?.no_of_tasks}</p>
          </li>
          <li>
            <p className={`${styles.Title}`}>Frequency:</p>
            <p className={`${styles.Content}`}>{item?.frequency}</p>
          </li>
          <li>
            <p className={`${styles.Title}`}>Repeats on:</p>
            <p className={`${styles.Content}`}>{repeatText}</p>
          </li>
          <li>
            <p className={`${styles.Title}`}>Property:</p>
            <p className={`${styles.Content} ${styles.Hover}`} onClick={(e) => {
              e.preventDefault();
              redirect.push('/properties/details/' + item?.property_id);
            }}>{item?.property_name !== '' ? item?.property_name : '-'}</p>
          </li>
        </ul>
      </div>
      <div className={`${styles.ProspectCardFootSec}`}>
        <p className={`${styles.LeaseConDate}`}>{dayjs(item?.created_at).fromNow()}</p>
        <div className={`${styles.MainReqConDropBU}`}>
          <Dropdown onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
            <Dropdown.Toggle id="dropdown-basic" className={item?.is_archived === 1 ? `${styles.ReferStatusBU} ${styles.StatusBuRed}` : `${styles.ReferStatusBU} ${styles.StatusBuGreen}`}>
              {item?.is_archived === 1 ? "Disable" : "Enable"}{" "}
              <ChevronDown className={`${styles.DownArrowStatus}`} />
            </Dropdown.Toggle>

            <Dropdown.Menu className="DropDownMenuBoxCus">
              {item?.is_archived === 1 && (<Dropdown.Item className="DropDListWIcon" onClick={(e) => { setArchiveTaskModalOpen(true); setSelectedId(item?.id); setIsArchive(false); }}>Enable</Dropdown.Item>)}
              {item?.is_archived === 0 && (<Dropdown.Item className="DropDListWIcon" onClick={(e) => { setArchiveTaskModalOpen(true); setSelectedId(item?.id); setIsArchive(true); }}>Disable</Dropdown.Item>)}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  </div>);
};

export default TaskCard;